import { render, staticRenderFns } from "./HeroRow.vue?vue&type=template&id=95f1031a&scoped=true&"
import script from "./HeroRow.vue?vue&type=script&lang=js&"
export * from "./HeroRow.vue?vue&type=script&lang=js&"
import style0 from "./HeroRow.vue?vue&type=style&index=0&id=95f1031a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f1031a",
  null
  
)

export default component.exports